import React, { Component } from "react";
import { connect } from "react-redux";
import Header from "../Header/header";
import HeaderContainer from "../Header/LandingHeader/HeaderContainer";
import MyFooter from "../Footer/footer";
import MyPoints from "./mypoints";
import BestTeam from "./bestTeam";
import WinPoints from "./winpoints";
import WinPointsTeam from "./winPointsTeam";
import { Parse } from "parse";

import {
  ColShadow,
  Contentstyled,
  Layoutstyled,
  SpanBlue
} from "../Constants/style";
import { Icon, Menu, Row } from "antd";

class Fidelity extends Component {
  constructor(props) {
    super(props);
    this.state = {
      displayMyPoints: "",
      displayHowToWin: "none"
    };
  }

  handleDisplayNav = e => {
    if (e.key === "0") {
      this.setState({
        displayMyPoints: "",
        displayHowToWin: "none"
      });
    } else if (e.key === "1") {
      this.setState({
        displayMyPoints: "none",
        displayHowToWin: ""
      });
    }
  };

  isUserProfessional = () => {
    if(Parse.User.current().attributes.professional === true){
      return <BestTeam/>
    } else return <MyPoints />
  }

  isUserProfessional2 = () => {
    if(Parse.User.current().attributes.professional === true){
      return <WinPointsTeam/>
    } else return  <WinPoints />
  }


  render() {
    return (
      <Layoutstyled>
        <Header />
        <HeaderContainer />
        <Contentstyled>
          <Row type="flex" justify="center" align="top">
            <ColShadow
              style={{
                background: "#fff",
                padding: 24,
                radius: 4,
                marginBottom: 35
              }}
              xs={24}
              sm={24}
              md={24}
              lg={6}
              xl={5}
            >
              <Menu
                style={{ width: 200, border: "none" }}
                defaultOpenKeys={["sub1"]}
                mode="vertical"
                onClick={this.handleDisplayNav}
              >
                <Menu.Item key="0">
                  <SpanBlue><Icon type="star" /> {`Mes points`}</SpanBlue>
                </Menu.Item>
                <Menu.Item key="1">
                  <SpanBlue><Icon type="rise" />{`Obtenir des points`}</SpanBlue>
                </Menu.Item>
              </Menu>
            </ColShadow>
            <ColShadow
              style={{ background: "#fff", padding: 24, radius: 10 }}
              xs={24}
              sm={24}
              md={24}
              lg={{ span: 16, offset: 1 }}
              xl={{ span: 17, offset: 1 }}
            >
              <div style={{ display: this.state.displayMyPoints }}>
                {this.isUserProfessional()}
              </div>
              <div style={{ display: this.state.displayHowToWin }}>
              {this.isUserProfessional2()}
              </div>
            </ColShadow>
          </Row>
        </Contentstyled>
        <MyFooter />
      </Layoutstyled>
    );
  }
}

const mapStateToProps = globalReducers => globalReducers;
const connectedFidelity = connect(
  mapStateToProps,
  null
)(Fidelity);
export default connectedFidelity;
